import React from 'react';
import { TablePaginationConfig } from 'antd';
import { FilterValue, SorterResult } from 'antd/lib/table/interface';
import { PaginationInternalData } from 'hooks/pagination';

import {
  Table,
} from 'UI';
import { ClientLocation } from 'constants/interface';

import {
  MainContainer,
  DetailsButton,
} from './style';

interface LocationAddListProps {
  locations: ClientLocation[]
  onDetailsClick(locationId: string): void
  pageData: PaginationInternalData
  onTableChange: (
    pageData: TablePaginationConfig,
    filterData: Record<string, FilterValue | null>,
    sortData: SorterResult<
    ClientLocation> | SorterResult<ClientLocation>[],
  ) => void
  isLoading?: boolean
}

const LocationAddList = ({
  locations,
  onDetailsClick,
  pageData,
  onTableChange,
  isLoading,
}: LocationAddListProps): JSX.Element => (
  <MainContainer>
    <Table
      dataSource={locations}
      loading={isLoading}
      pagination={pageData}
      onChange={onTableChange}
      showSorterTooltip={false}
    >
      <Table.Column
        title="Encarregado"
        key="maintainer"
        dataIndex="maintainer"
        sorter={(): number => 0}
        sortOrder={pageData.orderBy === 'maintainer' ? pageData.order : undefined}
      />
      <Table.Column
        title="Fazenda"
        key="name"
        dataIndex="name"
      />
      <Table.Column
        title="Cidade"
        key="city"
        dataIndex="city"
        sorter={(): number => 0}
        sortOrder={pageData.orderBy === 'city' ? pageData.order : undefined}
        render={(city: string, clientLocation: ClientLocation) => (
          <span>{`${city ? `${city}/${clientLocation.state}` : '-'}`}</span>
        )}
      />
      <Table.Column
        title=""
        key="details"
        dataIndex="id"
        render={(locationId) => (
          <DetailsButton type="button" onClick={() => onDetailsClick(locationId)}>
            ver detalhes »
          </DetailsButton>
        )}
      />
    </Table>
  </MainContainer>
);

LocationAddList.defaultProps = {
  isLoading: false,
};

export default LocationAddList;
